import { reportAlertRuleAPI, ReportAlertRuleDataResponse } from 'api/viewer/report-alert-rule';
import { useEffect, useState } from 'react';

export default function useAlertRuleData(elementId: number, reportAlertRuleId: number) {
    const [ruleData, setRuleData] = useState<ReportAlertRuleDataResponse>();
    const loadRuleData = () => {
        return reportAlertRuleAPI.getReportAlertRuleData(elementId, reportAlertRuleId).then((response) => {
            if (response.status == 'OK') {
                setRuleData(response.data);
            }
        });
    };

    useEffect(() => {
        loadRuleData();
    }, [elementId, reportAlertRuleId]);

    return { ruleData, setRuleData, loadRuleData };
}
